export default __webpack_public_path__ + "static/media/ad_970x90_install_en@2x.cfb759e6.png";